/*
 * bf.js · Modo Black Friday.
 *  1) Contador DIARIO: cuenta hasta la próxima medianoche de Colombia (UTC-5, sin horario de verano) con el reloj del dispositivo.
 *  2) Pinta el botón de PÁGINA de Releasit (también el flotante). NUNCA toca nada dentro del formulario emergente.
 * Solo se carga en las páginas donde el modo está activo (lo decide snippets/bf.liquid).
 */
(function (root) {
  'use strict';

  var UTC_OFFSET_MS = 5 * 60 * 60 * 1000; // Colombia = UTC-5 todo el año
  var DAY_MS = 24 * 60 * 60 * 1000;

  /** Milisegundos que faltan para la próxima medianoche de Colombia: siempre entre 1 y 86 400 000. */
  function msToMidnight(nowMs) {
    var intoDay = (((nowMs - UTC_OFFSET_MS) % DAY_MS) + DAY_MS) % DAY_MS; // ms desde las 00:00 de Colombia
    return DAY_MS - intoDay;
  }

  /** Segundos que se muestran. Se redondea hacia arriba: nunca sale 00:00:00 y a las 12:00 am vuelve a 24:00:00. */
  function secondsLeft(nowMs) {
    return Math.ceil(msToMidnight(nowMs) / 1000);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /** 86400 -> "24:00:00" · 3723 -> "01:02:03" · algo que no es un número válido -> "00:00:00". */
  function format(totalSeconds) {
    if (!isFinite(totalSeconds) || totalSeconds < 0) return '00:00:00';
    var s = Math.floor(totalSeconds);
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }

  var api = { msToMidnight: msToMidnight, secondsLeft: secondsLeft, format: format };

  function init() {
    var metaBoton = document.querySelector('meta[name="bf-button-text"]');
    var metaFrases = document.querySelector('meta[name="bf-marquee-text"]');
    var cfg = { // textos opcionales (Configuración del tema → Black Friday); vacíos = se conserva el texto de la tienda
      buttonText: metaBoton ? (metaBoton.getAttribute('content') || '').trim() : '',
      frases: metaFrases ? (metaFrases.getAttribute('content') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean) : [],
    };

    /* ---------- contador ---------- */
    function setText(node, text) {
      // Se cambia el dato del nodo de texto (no la lista de hijos) para no despertar a los observadores del documento.
      if (node.firstChild && node.firstChild.nodeType === 3) { if (node.firstChild.data !== text) node.firstChild.data = text; }
      else node.textContent = text;
    }
    function tick() {
      var text = format(secondsLeft(Date.now()));
      var nodes = document.querySelectorAll('[data-bf-timer]');
      for (var i = 0; i < nodes.length; i += 1) setText(nodes[i], text);
    }
    function loop() {
      tick();
      root.setTimeout(loop, 1000 - (Date.now() % 1000) + 20); // alineado al siguiente segundo
    }

    /* ---------- texto del botón de compra de la PÁGINA (Releasit): el modo NO lo repinta, solo puede cambiarle el texto ---------- */
    function isPageButton(btn) {
      return !btn.closest('#_rsi-cod-form-modal, [class*="_rsi-modal"]') &&
        !btn.matches('._rsi-modal-submit-button, ._rsi-buy-now-custom-additionals-button');
    }
    function labelSpan(btn) { return btn.querySelector(':scope > span') || btn.querySelector('span'); }
    function labelOk(btn) {
      var sp = labelSpan(btn);
      return !sp || sp.textContent === cfg.buttonText; // se compara el texto REAL: la app puede reescribirlo sin tocar atributos
    }
    function setLabel(btn) {
      var sp = labelSpan(btn);
      if (sp && sp.textContent !== cfg.buttonText) sp.textContent = cfg.buttonText;
    }
    // Disyuntor: si otro motor de diseño (flora, combo-temporada...) o la propia app también reescribe esta etiqueta, los dos se corregirían sin fin y la página
    // se congelaría. Pasados MAX_REPINTADOS cambios dentro de una ventana corta, el modo cede ese botón y lo marca con data-bf-cede.
    var VENTANA_MS = 2000;
    var MAX_REPINTADOS = 20;
    function ahora() { return root.performance && root.performance.now ? root.performance.now() : Date.now(); }
    function watch(btn) {
      if (!cfg.buttonText || !isPageButton(btn) || btn.getAttribute('data-bf-cede')) return;
      setLabel(btn);
      if (btn.__bfWatch) return;
      btn.__bfWatch = true;
      var inicio = ahora();
      var repintados = 0;
      var obs = new MutationObserver(function () {
        if (labelOk(btn)) return; // nadie la tocó
        var t = ahora();
        if (t - inicio > VENTANA_MS) { inicio = t; repintados = 0; }
        repintados += 1;
        if (repintados > MAX_REPINTADOS) { obs.disconnect(); btn.setAttribute('data-bf-cede', '1'); return; }
        setLabel(btn); // la app redibujó la etiqueta (p. ej. al cambiar de variante): se vuelve a poner la del modo
      });
      obs.observe(btn, { childList: true, subtree: true, characterData: true });
    }
    function scan() {
      if (!cfg.buttonText) return;
      var list = document.querySelectorAll('._rsi-buy-now-button');
      for (var i = 0; i < list.length; i += 1) watch(list[i]);
    }

    /* ---------- la barra deslizante de la tienda (ticker): colores de Black Friday y frases del modo ---------- */
    // Cada tema/landing arma la suya; aquí se listan las que existen en las tiendas. `barra` = el contenedor que recibe los colores (.bf-marq);
    // `textos` = los elementos que llevan cada frase. Solo se toca la PRIMERA de cada tipo (la del encabezado); una igual más abajo en la página no.
    var BARRAS_DESLIZANTES = [
      { barra: '.horizontal-ticker', textos: '.horizontal-ticker__item' },                    // Br importaciones: ticker del encabezado
      { barra: '[class*="scrolling-sections--"]', textos: '[class*="scrolling-text-"]' },       // Tienda Prime: sección «scroll_text» del encabezado
      { barra: '.flora-ticker', textos: '.flora-ticker__item' },                               // landing «flora» (reloj de bolsillo)
      { barra: '.ct-ann', textos: '.ct-ann__item' },                                            // landing «combo-temporada»
    ];
    function barrasDeslizantes() {
      for (var k = 0; k < BARRAS_DESLIZANTES.length; k += 1) {
        var def = BARRAS_DESLIZANTES[k];
        var barra = document.querySelector(def.barra);
        if (!barra || barra.classList.contains('bf-marq')) continue;
        barra.classList.add('bf-marq');
        if (!cfg.frases.length) continue; // sin frases configuradas solo se recolorea: el texto de la tienda se conserva
        // Cada mensaje DISTINTO recibe la siguiente frase (en círculo) y todas sus copias reciben la misma: así la repetición que usa el tema para que el
        // movimiento no se corte sigue siendo idéntica. Lo que el tema controla con JavaScript (elementos con data-*) no se toca.
        var items = barra.querySelectorAll(def.textos);
        var asignada = {};
        var n = 0;
        for (var i = 0; i < items.length; i += 1) {
          var el = items[i];
          if (el.attributes.length && Array.prototype.some.call(el.attributes, function (a) { return /^data-/.test(a.name); })) continue;
          var original = el.textContent.trim();
          if (!(original in asignada)) { asignada[original] = cfg.frases[n % cfg.frases.length]; n += 1; }
          el.textContent = asignada[original]; // textContent: una frase con HTML se escribe como texto, nunca como elementos
        }
      }
    }

    /* ---------- cartel de respaldo: landings sin la galería del tema ---------- */
    // Si la página no trae el cartel desde la galería (landing armada con banners), se coloca justo después del primer banner con imagen
    // (o, si no hay ninguna, después de la primera sección visible). La plantilla la escribe snippets/bf.liquid junto a la barra.
    var BLOQUES_DE_FOTO = ['.ct-hero__media', '.flora-buybox__gallery']; // landings «combo-temporada» y «flora» (reloj de bolsillo) de Br importaciones
    function cartelDeRespaldo() {
      if (document.querySelector('.bf-badge')) return; // la galería ya lo trae
      var plantilla = document.getElementById('bf-badge-template');
      var main = document.getElementById('MainContent');
      if (!plantilla || !main) return;
      // Motores de diseño propios que ponen la galería y la ficha del producto en la MISMA sección: el cartel va dentro del bloque de la foto, debajo de ella.
      for (var k = 0; k < BLOQUES_DE_FOTO.length; k += 1) {
        var bloque = main.querySelector(BLOQUES_DE_FOTO[k]);
        if (bloque && root.getComputedStyle(bloque).display !== 'none') { bloque.insertAdjacentHTML('beforeend', plantilla.innerHTML); return; }
      }
      var primero = null;
      var ancla = null;
      for (var i = 0; i < main.children.length; i += 1) {
        var hijo = main.children[i];
        if (root.getComputedStyle(hijo).display === 'none') continue;
        if (!primero) primero = hijo;
        if (hijo.querySelector('img, video, picture')) { ancla = hijo; break; }
      }
      ancla = ancla || primero;
      if (ancla) ancla.insertAdjacentHTML('afterend', plantilla.innerHTML);
      else main.insertAdjacentHTML('afterbegin', plantilla.innerHTML);
    }

    api.tick = tick;
    api.scan = scan;

    barrasDeslizantes(); // lo primero: así la barra de la tienda cambia de colores y de frases lo antes posible
    cartelDeRespaldo(); // antes del primer tick: así su contador recibe la hora enseguida
    tick();
    loop();
    scan();
    document.addEventListener('visibilitychange', tick);
    if (cfg.buttonText && 'MutationObserver' in root) { // solo hace falta vigilar botones nuevos si el modo cambia el texto del botón
      var queued = false;
      new MutationObserver(function () { // botones que la app crea más tarde (se mira como máximo una vez por cuadro)
        if (queued) return;
        queued = true;
        root.requestAnimationFrame(function () { queued = false; scan(); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BF = api;
})(typeof window !== 'undefined' ? window : globalThis);
